import React, { PropTypes, Component } from 'react';
import WatchPropTypes from 'common/PropTypes';
import connectPlayer from 'webapp/player/connectPlayer';
import UpcomingAlert from '@alias/UpcomingAlert';
import { getPlayerBackgroundStyle } from 'webapp/player/util';
import { isEmpty } from 'lib/util';
import { intlShape } from 'common/injectIntl';

/**
 * This UI component has a player connected to it.
 * Due to the fact that the connectPlayer function expects a component with a "ref" to "playerElement",
 * the "alertable" HOC can not be used to manage the UpcomingAlert's state.
 */
class HeroPlaybackPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayAlert: false
        };
        this.onClose = this.onClose.bind(this);
        this.getAlertEl = this.getAlertEl.bind(this);
    }

    componentWillMount() {
        if (this.showAlertOnMount()) {
            this.setState({ displayAlert: true });
        }
    }

    onClose() {
        this.setState({ displayAlert: false });
    }

    getAlertEl() {
        const { alertContent, selectedStream, playingStream, messages, intl: { formatMessage } } = this.props;
        const stream = playingStream || selectedStream;
        if (this.state.displayAlert) {
            const moreText = !isEmpty(stream) ?
                formatMessage(messages['schedule.module.alert.moreText'], { name: stream.name }) : '';
            return (
                <UpcomingAlert
                    animate="fade"
                    content={alertContent}
                    moreText={moreText}
                    // page-shell.css has .evp-player class zIndex at 1000031
                    style={{ position: 'absolute', top: '0px', zIndex: 1000050 }}
                    onClose={this.onClose}
                />
            );
        }
        return null;
    }

    showAlertOnMount() {
        const { alertContent } = this.props;
        if (!isEmpty(alertContent)) {
            return true;
        }
        return false;
    }

    render() {
        return (
            <div
                className="media-wrapper media-wrapper--embed espnplayerwrapper"
                style={getPlayerBackgroundStyle(this.props.selectedContent)}
            >
                {this.getAlertEl()}
                <div>
                    <div ref="playerContainer" id="watchespn-player-container">&nbsp;</div>
                </div>
            </div>
        );
    }
}

HeroPlaybackPage.propTypes = {
    alertContent: WatchPropTypes.content,
    selectedContent: WatchPropTypes.content,
    selectedStream: WatchPropTypes.stream,
    playingStream: WatchPropTypes.stream,
    intl: intlShape.isRequired,
    messages: PropTypes.object.isRequired
};

export default connectPlayer(HeroPlaybackPage);
export { HeroPlaybackPage as BaseHeroPlaybackPage };



// WEBPACK FOOTER //
// ./app/webapp/page/hero/HeroPlaybackPage.js